import type { ReactElement } from 'react';

import { Button, Flex, Heading, Text } from '@rango-dev/whale';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '../hooks/reduxHooks';

import styles from './NotFound.module.css';

function NotFound(): ReactElement {
  const { t } = useTranslation();
  const { isDarkMode } = useAppSelector((state) => state.settings);

  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate({ pathname: '/' });
  };

  return (
    <Flex
      direction="column"
      align="center"
      justify="center"
      gap="8"
      py={{ initial: '75px', sm: '110px' }}>
      <img
        src={isDarkMode ? '/imgs/general/not-found-dark.png' : '/imgs/general/not-found-light.png'}
        className={styles.image}
      />
      <Flex direction="column" align="center" gap="2">
        <Heading size={{ initial: '6', md: '8' }} align="center">
          {t('Page Not Found')}
        </Heading>
        <Text size={{ initial: '3', md: '2' }} weight="regular" color="gray" align="center">
          {t('Sorry, we couldn’t find that page.')}
        </Text>
      </Flex>
      <Button
        id="not-found-page-back-to-home-btn"
        size={{ initial: '3', md: '4' }}
        onClick={handleBackClick}
        className={styles.actionButton}>
        {t('Back To Home')}
      </Button>
    </Flex>
  );
}

export default NotFound;
